// extracted by mini-css-extract-plugin
module.exports = {"Intensity":"styles_Intensity__lpi0w","visible":"styles_visible__i1fQU","dot":"styles_dot__4aXIM","active":"styles_active__Bzf_Z"};